import Api from 'services/Api';
import _ from 'lodash';
import moment from 'moment';
import store from 'store/index';
import Validator from 'services/Validator';
import { previousValid } from 'store/generators/step';

/**
 * Mutation Types
 *
 * @type {Object}
 */
const mutationTypes = {
    RESET: 'RESET',
};

/**
 * Initial State
 *
 * @type {Object}
 */
const state = {

};

/**
 * Getters.
 *
 * @type {Object}
 */
const getters = {

};

// Actions
const actions = {
    /**
     * Save the step by submitting to the server.
     */
    save({getters, dispatch}, payload) {
        // We might change this to something which 
        // is a bit cleaner...
        payload.data = state;

        Api.claims.save(payload).then((response) => {
            return response;
        });
    },

    /**
     * Loads the step being received from the Server, to be placed in the state.
     */
    load({ dispatch, action, commit }, step) {
        const data = _.deeply(_.mapKeys)(step, (value, key) => _.camelCase(key)).data;
        // const theClaimant = data.theClaimant;
        // const claimantDetails = data.claimantDetails;

        // const proms = _.deeply(_.map)(theClaimant, (value, key) => dispatch('updateClaimantValue', { key, value }))
        //             + _.deeply(_.map)(claimantDetails, (value, key) => dispatch('updateClaimantDetail', { key, value }));

        return Promise.all([]);
    },

    /**
     * Performs any processing once the data from the server has been stored.
     * This is a good place to do calculations or dispatch other actions which
     * are used to refresh/update calculated data on other steps/components.
     */
    process({ rootState }) {
        store.dispatch('fatal/dependency/step/setStepNumberValid', {
            stepNo: 8,
            valid: previousValid(rootState, 8), // needs updating with real validity
        });
    },

    /**
     * Validate the step.
     *
     * @param commit
     */
    validate({ rootState }) {
        store.dispatch('fatal/dependency/step/setStepNumberValid', {
            stepNo: 8,
            valid: previousValid(rootState, 8), // 8 Is valid is 7 is valid.
        });
    },

    /**
     * Resets the step back to defaults
     */
    reset({ commit }) {
        store.dispatch('fatal/dependency/step/setStepNumberValid', {
            stepNo: 8,
            valid: false,
        });

        commit(mutationTypes.RESET);
    },
};

// Mutations
const mutations = {
    /**
     * Reset state.
     */
    [mutationTypes.RESET](state) {

    },
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
};


// WEBPACK FOOTER //
// ./src/store/modules/fatal/dependency/calculateLoss.js